import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AboutPageOneComponent } from "./components/about-page-one/about-page-one.component";
import { BlogDetailsPageComponent } from "./components/blog-details-page/blog-details-page.component";
import { NewsComponent } from "./components/news/news.component";
import { ContactPageComponent } from "./components/contact-page/contact-page.component";
import { HomePageTwoComponent } from "./components/home-page-two/home-page-two.component";
import { ErrorPageComponent } from "./error-page/error-page.component";
import { ActivityComponent } from "./components/activity/activity.component";
import { PrivacyPolicyComponent } from "./components/privacy-policy/privacy-policy.component";
import { PublicNewsComponent } from "./components/public-news/public-news.component";
import { NewsDetailsComponent } from "./components/news-details/news-details.component";
import { ActivityDetailsComponent } from "./components/activity-details/activity-details.component";
import { PublicNewsDetailsComponent } from "./components/public-news-details/public-news-details.component";



export const routes: Routes = [
    { path: '', component: HomePageTwoComponent },
    { path: 'news', component: NewsComponent },
    { path: 'news-details/:id', component: NewsDetailsComponent },
    { path: 'activity-details/:id', component: ActivityDetailsComponent },

    { path: 'public-news', component: PublicNewsComponent },
    { path: 'public-news-details/:id', component: PublicNewsDetailsComponent },
    { path: 'details', component: BlogDetailsPageComponent },
    { path: 'activity', component: ActivityComponent },
    { path: 'contact', component: ContactPageComponent },
    { path: 'about', component: AboutPageOneComponent },
    { path: 'privacy-policy', component: PrivacyPolicyComponent },

    { path: '**', component: ErrorPageComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }